export const cardDetails = {
    0: {
        imgUrl: "./img/caro/infi/1.png",
        title: "Text 1",
        aspect: (343/543),
        offset: 0,
        type:1
    },

    1: {
        imgUrl: "./img/caro/infi/2.png",
        title: "Text 2",
        aspect: (727/534),
        offset: 10,
        type:2
    },

    2: {
        imgUrl: "./img/caro/infi/3.png",
        title: "Text 3",
        aspect: (343/543),
        offset: -5,
        type:1
    },

    3: {
        imgUrl: "./img/caro/infi/4.png",
        title: "Text 2",
        aspect: (727/534),
        offset: 5,
        type:2
    },
}